module.exports = __webpack_public_path__ + "static/media/17b.43f7dfab.jpg";